import examservice from "@/services/examservice.js";

export const namespaced = true;

export const state = {
  selected: {},
  ques: {},
  proceed: false,
  question: [],
  subjects: [],
  start_config: {},
  testtime: 0,
  cquestion: [],
  ctrackid: "",
  uploaded: false,
  allinstitutions: [],
  alltopics: [],
  allcategories: [],
  started: false,
  answered: [],
  mode_config: {},
  currentsubject: "",
  currenttabquestions: [],
  currentquestionid: "",
  changedconfig: "",
  submitted: false,
  alreadysub: false,
  totalscore: 0,
  modeconfigupadated: false,
  currenttime: 0,
  refdiscount: 0,
  updatingstartconfig: "No",
  allretrieve: []
};

export const mutations = {
  SET_SELECTED(state, selectObj) {
    state.selected = selectObj;
    state.submitted = false;
  },
  SET_PROCEED(state) {
    state.proceed = true;
  },
  SET_QUESTION(state, que) {
    state.question = que;
  },
  SET_SUBJECTS(state, subjects) {
    state.subjects = subjects;
  },
  SET_QUES(state, quess) {
    state.ques = quess;
  },
  SET_CONFIG(state, config) {
    state.start_config = config;
    state.testtime = config.testtime;
  },
  SET_STARTED(state) {
    state.started = true;
  },
  SET_ANSWERED(state, answer) {
    if (answer.action == "pop") {
      state.answered.splice(answer.index, 1);
      state.answered.push(answer.answer);
    } else if (answer.action == "push") {
      state.answered.push(answer.answer);
    }
  },
  SET_CURRENT_SUBJECT(state, subque) {
    state.currentsubject = subque;
  },
  SET_CURRENT_TAB_QUESTIONS(state, tabquestionsarray) {
    state.currenttabquestions = tabquestionsarray;
  },
  SET_CURRENT_QUESTION_ID(state, que_id) {
    state.currentquestionid = que_id;
  },
  SET_CHANGE(state, change) {
    state.changedconfig = change;
  },
  SET_CANSWERED(state, answered) {
    state.answered = answered;
  },
  SET_CMODE_CONFIG(state, mode_config) {
    state.mode_config = mode_config;
  },
  DESTROY_STARTED(state) {
    state.started = false;
  },
  SET_ALREADY_SUB(state, value) {
    state.alreadysub = value;
  },
  DESTROY_ALREADY_SUB(state) {
    state.alreadysub = false;
  },
  SET_TOTAL_SCORE(state, totscore) {
    state.totalscore = totscore;
  },
  CHANGE_MODE_CONFIG_VISITED(state, visitedArray) {
    // console.log(state.mode_config.visited)
    state.mode_config.visited = visitedArray;
    // console.log(state.mode_config.visited)
  },
  CHANGE_MODE_CONFIG_ELAPSED(state, elapsedArray) {
    // console.log(state.mode_config.elapsed)
    state.mode_config.visited = elapsedArray;
    // console.log(state.mode_config.elapsed)
  },
  SET_MODE_CONFIG_UPDATED(state) {
    state.modeconfigupadated = true;
  },
  REF_DISCOUNT(state, data) {
    state.refdiscount = data;
  },
  ALL_RETRIEVE(state, data) {
    state.allretrieve = data;
  },
  DESTROY_ALL(state) {
    state.selected = {};
    state.ques = {};
    state.proceed = false;
    state.question = {};
    state.start_config = {};
    state.cquestion = [];
    state.ctrackid = "";
    state.submitted = true;
    state.started = false;
    state.answered = [];
    state.currentsubject = "";
    state.currenttabquestions = [];
    state.currentquestionid = "";
    state.changedconfig = "";
  },
  UPDATE_TIME(state, newtime) {
    const getcconfig = state.start_config;
    let completed = "";
    let start = "";
    if (newtime == 0) {
      completed = "Yes";
      start = "No";
    } else {
      completed = "No";
      start = "Continue";
    }

    const newconfig = {
      completed: completed,
      start: start,
      category: getcconfig.category,
      mode: getcconfig.mode,
      mode_config: getcconfig.mode_config,
      title: getcconfig.title,
      structure: getcconfig.structure,
      course: getcconfig.course,
      level: getcconfig.level,
      institution_id: getcconfig.institution_id,
      institution: getcconfig.institution,
      institution_shortname: getcconfig.institution_shortname,
      total_time: newtime,
      track_id: getcconfig.track_id,
      totalquestions: getcconfig.totalquestions,
      test_source: getcconfig.test_source,
      config_dir: getcconfig.config_dir
    };

    state.start_config = newconfig;
    state.currenttime = newtime;
  },
  SET_UPLOADED(state) {
    state.uploaded = true;
  },
  ALL_INSTITUTIONS(state, allinsti) {
    state.allinstitutions = allinsti;
  },
  ALL_TOPICS(state, topics) {
    state.alltopics = topics;
  },
  ALL_CATEGORIES(state, allcategories) {
    state.allcategories = allcategories;
  },
  UPDATING_START_CONFIG_IN_PROGRESS(state, status) {
    state.updatingstartconfig = status;
  }
};

export const actions = {
  setSelect({ dispatch, commit }, selectObj) {
    commit("SET_SELECTED", selectObj);
    return examservice.sendSelect(selectObj).then(response => {
      if (response.data.ongoing) {
        dispatch("exam/setcontinuefromlogin", response.data.ongoingconfig, {
          root: true
        });
      } else {
        commit("SET_QUESTION", response.data.questions);
        commit("SET_SUBJECTS", response.data.subjects);
        commit("SET_CONFIG", response.data);
        commit("SET_CONFIG_ROOT", response.data, { root: true });
        commit("SET_CMODE_CONFIG", JSON.parse(response.data.mode_config));
      }
    });
  },
  updatetimeconfig({ commit }, newtime) {
    commit("UPDATE_TIME", newtime);
    commit("UPDATE_TIME_ROOT", newtime, { root: true });
  },
  setcontinuefromlogin({ commit }, responses) {
    commit("SET_QUESTION", responses.questions);
    commit("SET_SUBJECTS", responses.subjects);
    commit("SET_CONFIG", responses);
    commit("SET_CONFIG_ROOT", responses, { root: true });
    commit("SET_ONGOING", null, { root: true });
    commit("SET_STARTED");
    commit("SET_CANSWERED", responses.answered);
    commit("SET_CMODE_CONFIG", responses.mode_config);
  },
  destroyAll({ commit }) {
    commit("DESTROY_ALL");
  },
  retrieveInstitutions({ commit }, query = '') {
    return examservice.getAllInstitutions(query).then(response => {
      commit("ALL_INSTITUTIONS", response.data.data);
      return response.data
    });
  },
  retrieveTopics({ commit }) {
    return examservice.getTopics().then(response => {
      commit("ALL_TOPICS", response.data);
    });
  },
  retrieveCategories({ commit }) {
    return examservice
      .getCategories()
      .then(response => {
        commit("ALL_CATEGORIES", response.data);
      })
      .catch(() => {
        //console.log(error);
      });
  },
  startTest({ commit }) {
    commit("SET_STARTED");
    //console.log("Test Started")
  },
  addModeConfig({ commit }, modeConfig) {
    let visitedArray = state.mode_config.visited;
    let elapsedArray = state.mode_config.elapsed;
    let isPresentIndex = visitedArray.findIndex(
      x => x.trackid == modeConfig.trackid
    );
    //console.log(modeConfig)
    if (modeConfig.action == "visited") {
      if (isPresentIndex != -1) {
        visitedArray.splice(isPresentIndex, 1);
        visitedArray.push({
          trackid: modeConfig.trackid,
          timeLeft: modeConfig.timeLeft
        });
      } else {
        visitedArray.push({
          trackid: modeConfig.trackid,
          timeLeft: modeConfig.timeLeft
        });
      }
      commit("CHANGE_MODE_CONFIG_VISITED", visitedArray);
    } else if (modeConfig.action == "elapsed") {
      if (isPresentIndex != -1) {
        visitedArray.splice(isPresentIndex, 1);
        visitedArray.push({
          trackid: modeConfig.trackid,
          timeLeft: modeConfig.timeLeft
        });
      } else {
        visitedArray.push({
          trackid: modeConfig.trackid,
          timeLeft: modeConfig.timeLeft
        });
      }
      commit("CHANGE_MODE_CONFIG_VISITED", visitedArray);

      let isPresentinElapsed = elapsedArray.findIndex(
        x => x == modeConfig.trackid
      );

      if (isPresentinElapsed != -1) {
        elapsedArray.splice(isPresentinElapsed, 1);
      }
      elapsedArray.push(modeConfig.trackid);
      commit("CHANGE_MODE_CONFIG_ELAPSED", visitedArray);
    }
  },
  updateModeConfig({ commit }) {
    let modeconfig = state.mode_config;

    function proceedupdate() {
      let awaitingupdate = state.updatingstartconfig;

      if (awaitingupdate == "No") {
        clearInterval(updateInterval);

        return examservice
          .updateModeconfig(modeconfig, state.start_config.config_dir)
          .then(response => {
            commit("SET_MODE_CONFIG_UPDATED", response.data);
          });
      }
    }

    let updateInterval = setInterval(() => {
      proceedupdate();
    }, 1000);
  },
  addAnswer({ commit, getters, dispatch }, answer) {
    const quedetails = getters.getcurrentquestion;

    if (getters.getanswered.findIndex(o => o == quedetails[0].track_id) != -1) {
      let caindex = getters.getanswered.findIndex(
        o => o == quedetails[0].track_id
      );

      const answeredobj = {
        index: caindex,
        action: "pop",
        answer: {
          answer: answer,
          track_id: quedetails[0].track_id,
          correct: quedetails[0].correct,
          subject: quedetails[0].subject,
          course: quedetails[0].course,
          section: quedetails[0].section,
          structure: quedetails[0].structure,
          oeq_answer: quedetails[0].oeq_answer,
          topic_reference: quedetails[0].topic_reference
        }
      };
      commit("SET_ANSWERED", answeredobj);
      dispatch("updatestartconfig");
    } else {
      const answeredobj = {
        action: "push",
        answer: {
          answer: answer,
          track_id: quedetails[0].track_id,
          correct: quedetails[0].correct,
          subject: quedetails[0].subject,
          course: quedetails[0].course,
          section: quedetails[0].section,
          structure: quedetails[0].structure,
          oeq_answer: quedetails[0].oeq_answer,
          topic_reference: quedetails[0].topic_reference
        }
      };
      commit("SET_ANSWERED", answeredobj);
      dispatch("updatestartconfig");
    }

    //console.log(answeredobj)
  },
  setSubject({ commit }, subject) {
    commit("SET_CURRENT_SUBJECT", subject);
    //console.log(subject)
  },
  setTabQuestions({ commit }, tabquestionsarray) {
    commit("SET_CURRENT_TAB_QUESTIONS", tabquestionsarray);
  },
  setCurrentQuestionId({ commit }, que_id) {
    commit("SET_CURRENT_QUESTION_ID", que_id);
    //console.log(que_id)
  },
  updatestartconfig({ commit, getters }) {
    let startconfig = getters.getstartconfig;
    let answered = getters.getansweredforupdate;
    let modeconfig = getters.getmodeconfig;

    commit("UPDATING_START_CONFIG_IN_PROGRESS", "Yes");

    return examservice
      .updateConfig(startconfig, answered, modeconfig)
      .then(response => {
        commit("UPDATING_START_CONFIG_IN_PROGRESS", "No");
        commit("SET_TOTAL_SCORE", response.data);
        commit("SET_CHANGE", response.data);
      });
  },
  setAlreadysub({ commit }) {
    commit("SET_ALREADY_SUB", true);
  },
  UnsetAlreadysub({ commit }) {
    commit("SET_ALREADY_SUB", false);
  },
  destroyAlreadysub({ commit }) {
    commit("DESTROY_ALREADY_SUB");
  },
  autoSubmission({ commit, dispatch }) {
    commit("DESTROY_STARTED");
    //commit("ALREADY_SUBMITTED")
    try {
      return dispatch("updatestartconfig").then(() => {
        commit("DESTROY_ALL");
        dispatch("exam/destroyAll", null, { root: true });
        //dispatch("loginmaster/destroyAll", null, { root: true });
        dispatch("destroyalL", null, { root: true });
      });
    }catch(err){
      commit("UN_SUBMIT")
    }
    
  },
  logOut({ commit }) {
    commit("DESTROY_ALL");
  },
  destroyStarted({ commit }){
    commit("DESTROY_STARTED");
  },
  retrieveRefdiscount({ commit }, useremail) {
    return examservice.getRefdiscount(useremail).then(response => {
      commit("REF_DISCOUNT", response.data);
      // console.log(response.data)
      return response.data;
    });
  },
  applyCouponDiscount({ commit }, payload) {
    return examservice.applyCouponDisc(payload).then(response => {
      commit("REF_DISCOUNT", response.data);
      // console.log(response.data)
      return response.data;
    });
  },
  retrieveAllInstitutions({ commit }, query = '') {
    return examservice.getAllInstitutions(query).then(response => {
      commit("ALL_RETRIEVE", response.data);

      return response.data
    });
  },
  retrieveAllInstitutionsTabled({ commit }, query = '') {
    return examservice.getAllInstitutionsTabled(query).then(response => {
      commit("ALL_RETRIEVE", response.data);

      return response.data
    });
  },
  retrieveAllCategories({ commit }, query = '') {
    return examservice.getAllCategories(query).then(response => {
      commit("ALL_RETRIEVE", response.data);

      return response.data
    });
  },
  retrieveAllCategoriesTabled({ commit }, query = '') {
    return examservice.getAllCategoriesTabled(query).then(response => {
      commit("ALL_RETRIEVE", response.data);

      return response.data
    });
  },
};

export const getters = {
  getcurrentquestion: state => {
    return state.currenttabquestions[0].filter(
      x => x.track_id == state.currentquestionid
    );
  },
  getanswered: state => {
    return state.answered.map(x => x.track_id);
  },
  getanswer: (state, getters) => {
    //console.log(state.currentquestionid)
    let ansindex = getters.getanswered.findIndex(
      o => o == state.currentquestionid
    );
    //console.log(getters.getanswered.findIndex(o => o == state.currentquestionid))
    if (
      ansindex != -1
    ) {
      let answer = state.answered.find((x) => {
        return x.track_id == state.currentquestionid
      })
      return answer.answer;
    } else {
      return "";
    }
  },
  getmodeconfig: (state) => {
    return state.mode_config;
  },
  getstartconfig: (state, getters, rootState) => {
    return rootState.start_config;
  },
  getansweredforupdate: state => {
    return state.answered;
  }
};
